/* eslint-disable react/prop-types */

import React from "react";
import { PropTypes } from "prop-types";
import { graphql, Link } from "gatsby";
import Button from "~components/Button";
import CaseStudies from "~components/CaseStudies";
import Layout from "~components/Layout";
import SEO from "~components/SEO";
import SectionIntro from "~components/SectionIntro";
import TyperSection from "~components/TyperSection";
import PrimaryText from "~components/PrimaryText";
import { splitStringToParagraphs } from "~utils/helpers";

const IndexPage = ({ data, location }) => {
  const { frontmatter } = data.markdownRemark;

  return (
    <>
      <SEO
        customTitle={frontmatter.title}
        customDescription={frontmatter.seoDescription}
        customKeywords={frontmatter.seoKeywords}
        path={location.pathname}
      />

      <Layout className="index-page w-full relative bg-white">
        <TyperSection
          heading={frontmatter.heading}
          imageText={frontmatter.imageText}
          imageCaption={frontmatter.imageCaption}
          imageColor="navy"
          typerColor="blue"
        />

        <PrimaryText text={frontmatter.introText} />

        <section className="border-t-orange">
          <div className="grid pt-v7 xs:pt-v14 text-orange">
            <SectionIntro
              backgroundColor={frontmatter.strategyHeadingColor}
              textClass="fk-screamer text-orange"
              text={frontmatter.strategyHeading}
              className="grid-end-12 grid-start-1 py-v10 xs:py-v30 px-v10 xs:px-v5"
            />

            <article className="grid-end-6 xs:grid-end-8 mt-v4 xs:mt-v7">
              {splitStringToParagraphs(
                frontmatter.strategyContent,
                `mb-v3 b1 universal-sans`
              )}
            </article>

            <div className="grid-end-12 flex justify-center xs:mt-v14 mb-v7 xs:mb-v14">
              <Link to="/services">
                <Button
                  className=""
                  color="orange"
                  filled
                  text="See our services"
                />
              </Link>
            </div>
          </div>
        </section>

        <section className="border-t-orange">
          <div className="grid pt-v7 xs:pt-v14 text-orange">
            <SectionIntro
              backgroundColor={frontmatter.clientsHeadingColor}
              textClass="grand-slang text-off-white"
              text={frontmatter.clientsHeading}
              className="grid-end-12 xs:grid-end-8 xs:grid-start-1 py-v10 xs:py-v30 px-v5 xs:px-v5"
            />

            <article className="grid-end-6 xs:grid-end-8 mt-v4 xs:mt-v14">
              {splitStringToParagraphs(
                frontmatter.clientsContent,
                `mb-v1 xs:mb-v6 b1 universal-sans`
              )}
            </article>
          </div>
        </section>

        <CaseStudies
          className="index"
          caseStudies={data.allMarkdownRemark.edges}
          withLink
        />
        <section className="border-t-orange mt-v7 xs:mt-v14">
          <div className="grid text-orange mt-v7 xs:mt-v28">
            {frontmatter.communicationColumns.map(col => (
              <article className="grid-end-4 xs:grid-end-8 pt-v7 sm:pt-0 xs:mb-v10">
                <h3 className="absolute sm:relative top-0 mb-v0 xs:mb-v6 universal-sans b1">
                  {col.title}
                </h3>
                <p className="universal-sans b2">{col.text}</p>
              </article>
            ))}
          </div>

          <div className="grid">
            <div className="grid-end-12 grid-start-1 mt-v7 xs:mt-v14 mb-v7 xs:mb-v14 flex justify-center">
              <Link to="/services">
                <Button
                  className=""
                  color="orange"
                  filled
                  text="Work with us"
                />
              </Link>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.shape({})
    })
  }).isRequired,
  location: PropTypes.shape({}).isRequired
};

export default IndexPage;

export const query = graphql`
  query IndexPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        heading
        imageText
        imageCaption
        introText
        strategyHeading
        strategyHeadingColor
        strategyContent
        clientsHeading
        clientsHeadingColor
        clientsContent
        communicationColumns {
          title
          text
        }
        seoDescription
        seoKeywords
      }
    }
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "case-study-page" } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            heading
            priority
            workpage
            imageAspect
            bannerBackground
            bannerFont
            bannerFontColor
          }
        }
      }
    }
  }
`;
